import React, { ReactNode, useState, useEffect } from 'react';
import { css } from '@emotion/react';
import { BirdiTheme, breakpoints } from '@birdi/theme';
import * as styles from './styles';

interface OnboardingContainerProps {
  Section: React.FC<any>;
  leftSideImage?: string;
  leftSideContent?: React.ReactNode;
}

export const OnboardingContainer: React.FC<OnboardingContainerProps> = ({
  Section,
  leftSideImage: initialLeftSideImage,
  leftSideContent,
}) => {
  const [leftSideImage, setLeftSideImage] = useState(initialLeftSideImage);

  useEffect(() => {
    setLeftSideImage(initialLeftSideImage);
  }, [initialLeftSideImage]);
  return (
    <div
      css={css`
        height: 100vh;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        /* Margin from screen sides - adjust these values */
        // padding: 2rem;
        background-image: url('https://birdi-public.s3-ap-southeast-2.amazonaws.com/signup-flow/background.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(255, 255, 255, 0.8);
          z-index: 0;
        }

        @media (max-width: ${breakpoints.s}) {
          /* Margin from screen sides on mobile - adjust these values */
          padding: 1rem;
        }
      `}
    >
      <div
        css={(theme: BirdiTheme) => css`
          position: relative;
          z-index: 1;
          width: 65vw;
          min-width: 900px;
          max-width: 1600px;
          background-color: ${theme.mono0};
          border-radius: 1rem;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
          overflow: hidden;
          display: flex;
          height: 92vh;

          @media (max-width: ${breakpoints.s}) {
            height: 100%;
            width: 100%;
            min-width: unset;
            border-radius: 0.75rem;
          }
        `}
      >
        {/* OnboardingLayout - merged into this component */}
        <div css={styles.pageContainer}>
          {/* Left side - Desktop only */}
          <div css={styles.leftSide}>
            {/* Circle overlay pattern - sits on top of gradient */}
            <div
              css={css`
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 0;
                background-image: url('https://birdi-public.s3-ap-southeast-2.amazonaws.com/signup-flow/circle-overlay.png');
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                pointer-events: none;
              `}
            />
            {leftSideImage && (
              <div
                css={css`
                  position: absolute;
                  top: 2rem;
                  /* Extend beyond left edge - image can go off-frame */
                  left: -2rem;
                  right: 2rem;
                  bottom: 2rem;
                  z-index: 1;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                `}
              >
                <img
                  src={`https://birdi-public.s3-ap-southeast-2.amazonaws.com/signup-flow/${leftSideImage}.png`}
                  alt="Birdi application preview"
                  css={css`
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    object-position: left center;
                  `}
                />
              </div>
            )}
            {leftSideContent && (
              <div
                css={css`
                  position: relative;
                  z-index: 2;
                  width: 100%;
                  height: 100%;
                `}
              >
                {leftSideContent}
              </div>
            )}
          </div>

          {/* Right side - Form content */}
          <div css={styles.rightSide}>
            <div css={styles.contentCard}>
              <Section setLeftSideImage={setLeftSideImage} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingContainer;

